import { Locale } from 'date-fns'
import { de, enGB, fr, it } from 'date-fns/locale'
import { IdAndName } from 'src/service/view-model/base/IdAndName'
import { findReferenceObject } from 'src/service/view-model/base/Reference.utils'
import { SupportedLocale } from 'src/service/view-model/base/localization/SupportedLocale'

export interface LocaleObject extends IdAndName {
  group: string
}

interface LocaleDatePickerMap {
  [key: string]: Locale
}

const group1 = ''
const other = 'countryAutocompleteOther'

export const LOCALES: LocaleObject[] = [
  { name: 'German', id: 'de', group: group1 },
  { name: 'French', id: 'fr', group: group1 },
  { name: 'Italian', id: 'it', group: group1 },
  { name: 'English', id: 'en', group: group1 },

  { name: 'Albanian', id: 'sq', group: other },
  { name: 'Arabic', id: 'ar', group: other },
  { name: 'Belarusian', id: 'be', group: other },
  { name: 'Bulgarian', id: 'bg', group: other },
  { name: 'Catalan', id: 'ca', group: other },
  { name: 'Chinese', id: 'zh', group: other },
  { name: 'Croatian', id: 'hr', group: other },
  { name: 'Czech', id: 'cs', group: other },
  { name: 'Danish', id: 'da', group: other },
  { name: 'Dutch', id: 'nl', group: other },
  { name: 'Estonian', id: 'et', group: other },
  { name: 'Finnish', id: 'fi', group: other },

  { name: 'Greek', id: 'el', group: other },
  { name: 'Hebrew', id: 'iw', group: other },
  { name: 'Hungarian', id: 'hu', group: other },
  { name: 'Icelandic', id: 'is', group: other },
  { name: 'Indonesian', id: 'in', group: other },
  { name: 'Irish', id: 'ga', group: other },

  { name: 'Japanese', id: 'ja', group: other },
  { name: 'Korean', id: 'ko', group: other },
  { name: 'Latvian', id: 'lv', group: other },
  { name: 'Lithuanian', id: 'lt', group: other },
  { name: 'Macedonian', id: 'mk', group: other },
  { name: 'Malay', id: 'ms', group: other },
  { name: 'Maltese', id: 'mt', group: other },
  { name: 'Norwegian', id: 'no', group: other },
  { name: 'Polish', id: 'pl', group: other },
  { name: 'Portuguese', id: 'pt', group: other },
  { name: 'Romanian', id: 'ro', group: other },
  { name: 'Russian', id: 'ru', group: other },
  { name: 'Serbian', id: 'sr', group: other },
  { name: 'Slovak', id: 'sk', group: other },
  { name: 'Slovenian', id: 'sl', group: other },
  { name: 'Spanish', id: 'es', group: other },
  { name: 'Swedish', id: 'sv', group: other },
  { name: 'Thai', id: 'th', group: other },
  { name: 'Turkish', id: 'tr', group: other },
  { name: 'Ukrainian', id: 'uk', group: other },
  { name: 'Vietnamese', id: 'vi', group: other },
]

const LOCALE_DATEPICKER_MAP: LocaleDatePickerMap = {
  en: enGB,
  de: de,
  fr: fr,
  it: it,
}

export const getLocaleObject = (localeCode: string | undefined): LocaleObject | undefined => {
  return findReferenceObject(LOCALES, localeCode, 'id')
}

export const getLocaleName = (localeCode: string | undefined): string => {
  if (localeCode?.length !== 2) {
    localeCode = localeCode?.substring(0, 2)
  }
  const localeObject = getLocaleObject(localeCode)
  return localeObject ? localeObject.name : ''
}

export const getMainLocales = (): LocaleObject[] => {
  const mainLocales = LOCALES.filter((locale) => locale.group === group1)
  return mainLocales
}

const updateLocaleFromDateFnsForRegionLocale = (givenLocale: Locale, regionLocale: SupportedLocale): Locale => {
  const locale: Locale = {
    ...givenLocale,
  }

  if (regionLocale === 'en-US') {
    locale.options = {
      weekStartsOn: 0,
    }
  }

  return locale
}

export const getLocaleForDatePicker = (languageLocaleString: string, regionLocale: SupportedLocale): Locale => {
  let locale = LOCALE_DATEPICKER_MAP[languageLocaleString]
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!locale) {
    console.warn("The selected locale doesn't exists, selected default 'en'")
    locale = enGB
  }

  const updatedLocale = updateLocaleFromDateFnsForRegionLocale(locale, regionLocale)
  return updatedLocale
}
